module.exports = __webpack_public_path__ + "img/tab-light.f728c45d.png";